// src/store/api/productApi.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { base_url } from '../../../environment.jsx';
import { createStore } from '@reduxjs/toolkit';

export const productApi = createApi({
  reducerPath: 'productApi',
  baseQuery: fetchBaseQuery({ baseUrl: base_url,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: ['Product', 'Category', 'Store', 'storeData', 'ProductId', 'brand', 'unit', 'itemCode', 'warrantyList', 'Cart'],
  endpoints: (builder) => ({
    getProductList: builder.query({
      query: ()=> `product/productList`,
       providesTags: ['Product'],
    }),
    getProductDetailById: builder.query({
      query: (id) => `product/productList/${id}`,
      transformResponse: (response) => response.data,
      providesTags: (result, error, id) => [{ type: 'Product', id }],
    }),
   
    // In your API slice
    getNewProductId: builder.query({
      query: () => 'product/generateProductId',
     // Adjust based on your backend
    }),
    getItemCode: builder.query({
      query: () => `product/generate-itemCode`,
      providesTags: ['itemCode'],
    }),
    getStoreList: builder.query({
      query: () => '/store/store-list',
      providesTags: ['storeData'],
    }),
    getBrandList: builder.query({
      query: () => '/product/brand',
      // transformResponse: (response) => response.data,
      // console.log(response);
      providesTags: ['brand'],
    }),
    createBrand: builder.mutation({
         query: (newBrand) => ({
        url: '/product/addNewBrand',
        method: 'POST',
        body: newBrand,
      }),
      invalidatesTags: ['Product'],
    }),
   
    getUnitList: builder.query({
      query: () => '/product/unit',
      transformResponse: (response) => response.data,
      providesTags: ['unit'],
    }),
    createUnit: builder.mutation({
      query: (newUnit) => ({
        url: '/product/addNewUnit',
        method: 'POST',
        body: newUnit,
      }),
      invalidatesTags: ['unit'],
    }),
    deleteUnit: builder.mutation({
      query: (unitId) => ({
        url: `/product/unit/${unitId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['unit'],
    }),

    getTypeOfWarrantyList: builder.query({
      query: () => 'warrantylist',
      providesTags: ['warrantyList'],
    }),
    getCategoryCode: builder.query({
      query: () => '/category/generate-category-code',
      providesTags: () => [{ type: 'CategoryCode' }],
    }),
    getCategoryList: builder.query({
      query: () => '/category',
    }),
    getAvailableInventory: builder.query({
      query: () => '/product/product-remaining',
      transformResponse: (response) => response.data,
    }),
    createCategory: builder.mutation({
         query: (formData) => ({
        url: '/category/add-category',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['category'],
    }),
    deleteCategory: builder.mutation({
      query: (catId) => {
        console.log("Deleting category with ID:", catId); 

    
        return {
          url: '/category/delete-category',
          method: 'DELETE',
          body: { id: catId }, 
        };
      },
      invalidatesTags: ['category'],
    }),
    
    createProduct: builder.mutation({
      query: (values) => ({
        url: '/product/addNewProduct',
        method: 'POST',
        body: values,
      }),
      invalidatesTags: ['Product'],
    }),
   updateProduct: builder.mutation({
  query: ({ _id, body }) => ({
    url: `product/updateProduct/${_id}`,
    method: 'PATCH',
    body: body,
    headers: body instanceof FormData 
      ? {} 
      : { 'Content-Type': 'application/json' }
  }),
  invalidatesTags: [{ type: 'Product' }]
}),
updateCategory: builder.mutation({
  query: ({ id, formData }) => ({
    url: `/category/${id}`,
    method: 'PATCH',
    body: formData
  }),
  invalidatesTags: (result, error, { id }) => [{ type: 'User', id }],
}),
    deleteProduct: builder.mutation({ 
      query: (id) => ({
        url: `product/product/${id}`,
        method: 'DELETE',
      }),
         invalidatesTags: ['Product'],
    }),   
    
    filterProduct: builder.query({
      query: (args) => {  
      
        // Create URLSearchParams to prevent duplicates
        const params = new URLSearchParams();
        
        if (args.category && args.category !== 'all') {
          params.append('category', args.category);
        }
        
        if (args.search) {
          params.append('search', args.search);
        }
        
        const url = `product/filter?${params.toString()}`;
        const requestConfig = {
          url,
          method: 'GET'
        };
        
      
        
        return requestConfig;
      },
      providesTags: ['Product'],
    }),

    
  }),
});


export const {
    useGetProductDetailByIdQuery,
    useGetStoreListQuery,
    useGetBrandListQuery,
    useGetCategoryListQuery,
    useCreateCategoryMutation,
    useDeleteCategoryMutation,
    useGetNewProductIdQuery,
    useFilterProductQuery,
    useCreateProductMutation,
    useCreateBrandMutation,
    useCreateUnitMutation,
    useGetUnitListQuery,
    useDeleteUnitMutation,
    useUpdateProductMutation,
    useUpdateCategoryMutation,
    useDeleteProductMutation,
    useGetProductListQuery,
    useGetAvailableInventoryQuery
  } = productApi;
  